import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="24" height="24" rx="12" fill="#DFF4D4" />
    <g clipPath="url(#clip0_248_22474)">
      <path
        d="M12.5 16.7656C12.5 17.0277 12.2877 17.2396 12.026 17.2396H9.18229C7.87559 17.2396 6.8125 16.1765 6.8125 14.8698V9.18229C6.8125 7.87559 7.87559 6.8125 9.18229 6.8125H14.8698C16.1765 6.8125 17.2396 7.87559 17.2396 9.18229V12.026C17.2396 12.2881 17.0273 12.5 16.7656 12.5C16.504 12.5 16.2917 12.2881 16.2917 12.026V9.18229C16.2917 8.39836 15.6537 7.76042 14.8698 7.76042H9.18229C8.39836 7.76042 7.76042 8.39836 7.76042 9.18229V12.4806L9.09129 11.1497C9.8174 10.4231 10.999 10.4231 11.7256 11.1497L14.257 13.6811C14.4423 13.8664 14.4423 14.166 14.257 14.3513C14.1645 14.4437 14.0432 14.4902 13.9219 14.4902C13.8005 14.4902 13.6792 14.4437 13.5868 14.3513L11.0554 11.8199C10.699 11.4639 10.1188 11.4635 9.76147 11.8199L7.76042 13.8209V14.8698C7.76042 15.6537 8.39836 16.2917 9.18229 16.2917H12.026C12.2877 16.2917 12.5 16.5035 12.5 16.7656ZM13.9219 8.47135C14.7058 8.47135 15.3438 9.1093 15.3438 9.89323C15.3438 10.6772 14.7058 11.3151 13.9219 11.3151C13.1379 11.3151 12.5 10.6772 12.5 9.89323C12.5 9.1093 13.1379 8.47135 13.9219 8.47135ZM13.9219 9.41927C13.6607 9.41927 13.4479 9.6316 13.4479 9.89323C13.4479 10.1549 13.6607 10.3672 13.9219 10.3672C14.183 10.3672 14.3958 10.1549 14.3958 9.89323C14.3958 9.6316 14.183 9.41927 13.9219 9.41927ZM17.7135 15.3438H16.2917V13.9219C16.2917 13.6598 16.0793 13.4479 15.8177 13.4479C15.5561 13.4479 15.3438 13.6598 15.3438 13.9219V15.3438H13.9219C13.6603 15.3438 13.4479 15.5556 13.4479 15.8177C13.4479 16.0798 13.6603 16.2917 13.9219 16.2917H15.3438V17.7135C15.3438 17.9756 15.5561 18.1875 15.8177 18.1875C16.0793 18.1875 16.2917 17.9756 16.2917 17.7135V16.2917H17.7135C17.9752 16.2917 18.1875 16.0798 18.1875 15.8177C18.1875 15.5556 17.9752 15.3438 17.7135 15.3438Z"
        fill="#578100"
      />
    </g>
    <defs>
      <clipPath id="clip0_248_22474">
        <rect
          width="13"
          height="13"
          fill="white"
          transform="translate(6 5.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const IconFilledImage = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IconFilledImage;
